import { useQuery } from '@tanstack/react-query';
import cx from 'classnames';
import { ButtonVariants } from '@components/button/Button';
import { LinkStyledAsButton } from '@components/linkStyledAsButton/LinkStyledAsButton';
import { SimpleBar } from '@shared/components/simpleBar/simpleBar';
import { SETTINGS_INVITE_MEMBER_PATH } from 'restaurantAdmin/paths';
import typography from '~styles/typography.scss';
import { SettingsOutletHeader } from '../shared/SettingsOutletHeader';
import { useSettingsOutletScroll } from '../shared/useSettingsOutletScroll';
import { useRestaurant } from '../../context/useRestaurant';
import { getAdmins } from './apiHelpers';
import { TeamKebab } from './TeamKebab';
import styles from './TeamPage.scss';

export const TeamPage = () => {
  const { id: restaurantId } = useRestaurant();

  const { data: admins = [], refetch } = useQuery({
    queryKey: ['restaurants', restaurantId, 'restaurantAdmins'],
    queryFn: async () => getAdmins(restaurantId),
  });

  const { bodyScrollHostRef, bodyScrollHostStyle } = useSettingsOutletScroll({
    enabled: true,
  });

  return (
    <div className={styles.root}>
      <SettingsOutletHeader
        title="Team"
        actions={
          <LinkStyledAsButton
            to={SETTINGS_INVITE_MEMBER_PATH}
            variant={ButtonVariants.Secondary}
            className={styles.inviteTeamMemberButton}
            label="Invite Team Member"
          />
        }
      />
      <div
        ref={bodyScrollHostRef}
        className={styles.bodyScrollHost}
        style={bodyScrollHostStyle}
      >
        <SimpleBar className={styles.bodyScroll}>
          <table className={styles.teamTable}>
            <thead>
              <tr>
                <th className={typography.t2}>Status</th>
                <th className={typography.t2}>Full Name</th>
                <th className={typography.t2}>Email</th>
                <th className={typography.t2}>Role</th>
              </tr>
            </thead>
            <tbody>
              {admins.map((admin) => (
                <tr key={admin.id}>
                  <td>
                    <span
                      className={cx(
                        typography.t3,
                        styles.pill,
                        styles[admin.status],
                      )}
                    >
                      {admin.status}
                    </span>
                  </td>
                  <td className={typography.c2}>{admin.fullName}</td>
                  <td className={typography.c2}>{admin.email}</td>
                  <td className={cx(typography.c2, styles.roleCell)}>
                    {admin.role}
                  </td>
                  <td aria-label="options">
                    <TeamKebab
                      admin={admin}
                      refetchRestaurantAdmins={refetch}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </SimpleBar>
      </div>
    </div>
  );
};
